import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'regionName',
    label: i18n('entities.region.fields.regionName'),
  },
  {
    name: 'regionCode',
    label: i18n('entities.region.fields.regionCode'),
  },
  {
    name: 'countries',
    label: i18n('entities.region.fields.countries'),
    render: exporterRenders.stringArray(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.region.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.region.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
